// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"ebdc0eeb","471":"c6763a5b"}[chunkId] + ".chunk.js";
};